module.exports = __webpack_public_path__ + "img/mengniu.d905c055.png";